<template>
  <modal size="lg" @close="$emit('close')">
    <h3 slot="header" class="mb-0">{{ title || docTitle }}</h3>

    <div slot="body">
      <doc-content :doc="doc" :sections="sections" :context="context" />
    </div>

    <div slot="footer">
      <button type="button" class="btn btn-primary" @click="$emit('close')">Close</button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import DocContent from '@/components/Docs/DocContent'
import { getDoc } from '@/docs'

// A modal showing a doc (`doc` id) or an ad-hoc list of `sections`; the title defaults to the doc's.
export default {
  name: 'DocModal',
  components: { Modal, DocContent },
  props: {
    doc: { type: String, default: null },
    sections: { type: Array, default: null },
    title: { type: String, default: null },
    context: { type: Object, default: () => ({}) }
  },
  computed: {
    docTitle() {
      const doc = this.doc ? getDoc(this.doc) : null
      return doc ? doc.title : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Docs/DocModal.vue